import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PlatformDetect } from "@core/libs/platform/platform-detect";

@Injectable({
    providedIn: 'root'
  })
export class AuthCaptchaVerifyGuard{
    
  constructor(
    private platform: PlatformDetect,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree>{
    
    if (this.platform.isApp()) {
      return true;
    } else {
      return false;
    }
  }

}